// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const NetblockSourceTypeSchema = z.enum(['USER_PROVIDED','REVERSE_WHOIS','NAME_RESOLUTION','INTELLIGENCE','AI_EXPANSION','EXTERNAL_INTEGRATION','CONNECTOR_SUBNET'] as const);

export type NetblockSourceTypeType = `${z.infer<typeof NetblockSourceTypeSchema>}`

export default NetblockSourceTypeSchema;
